import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ApplicationStatus } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { SettingsService } from 'src/app/services/settings.service';
import { roomFinderUrl, websiteUrl } from 'src/app/utils/misc.utils';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-header',
    standalone: false,
    templateUrl: './header.component.html',
    styleUrl: './header.component.css'
})
export class HeaderComponent {
  auth = inject(AuthService);
  settings = inject(SettingsService);
  private router = inject(Router);

  collapsed: boolean = true;
  Status = ApplicationStatus;
  projectTitle = environment.projectTitle;
  toolbarColor = environment.toolbarColor;
  year = environment.currentAwardYear;

  roomFinderUrl = roomFinderUrl();
  websiteUrl = websiteUrl();

  isUserSection(): boolean {
    const path = this.router.url.split('?')[0];
    return path === '/profile' || path === '/history';
  }

  isAdminSection(): boolean {
    const path = this.router.url.split('?')[0];
    return ['/review-applicants', '/review-rooms', '/validate', '/analyze'].includes(path);
  }
}
